<template>
  <div class="new-invoice concepts box wrapper-rep-payments">
    <div class="title-container is-flex">
      <h3 class="title is-centered is-4 has-text-primary title-rep-payments">
        Pagos
      </h3>
      <div class="field is-centered">
        <input
          id="advanced"
          v-model="advanced"
          :disabled="cash"
          name="advanced"
          class="is-checkradio"
          :class="{ 'is-success': advanced }"
          type="checkbox"
          @change="onChangeAdvanced"
        >
        <label
          class="is-centered"
          for="advanced"
        >
          Opciones Avanzadas
        </label>
      </div>
      <div
        v-if="false"
        class="field is-centered"
      >
        <BTooltip
          label="Agregar partida"
          type="is-success"
        >
          <a
            v-if="!disabled"
            class="button add-concept is-success is-rounded"
            @click="addRow"
          >
            <BIcon icon="plus" />
            <span>
              &emsp;
              Agregar Pago
            </span>
          </a>
        </BTooltip>
      </div>
    </div>
    <AdvancedValues
      v-show="advanced"
    />
    <BTable
      :data="concepts"
      :columns="columns"
      :opened-detailed="openedDetailed"
      detailed
      detail-key="id"
      @details-close="onDetailsClose"
    >
      <template
        slot="header"
        slot-scope="props"
      >
        <span :class="{ 'header-label': props.column.label === 'SKU' }">
          {{ props.column.label }}
        </span>
        <AppTooltip
          v-if="props.column.meta"
          :label="props.column.meta"
        />
      </template>
      <template slot-scope="props">
        <BTableColumn
          field="paymentMethod"
          internal
        >
          <AppSelectField
            id="wayPay"
            name="wayPay"
            placeholder="Selecciona la forma de pago"
            :options="paymentTypeCatalog"
            :value="wayPay"
            :disabled="isLoading || disabled"
            required
            @input="onChangePayment($event, props.row.id)"
            @change="onChangePayment($event, props.row.id)"
          />
        </BTableColumn>
        <BTableColumn
          field="paymentDate"
          internal
        >
          <BDatetimepicker
            id="paymentDate"
            :value="privatePaymentDate"
            :disabled="isLoading || disabled"
            :date-parser="dateParser"
            horizontal-time-picker
            v-bind="calendarProps"
            icon="calendar-today"
            @input="onInput($event, props.row.id)"
          />
        </BTableColumn>
        <BTableColumn
          field="currency"
          internal
        >
          <AppSelectField
            id="currency"
            name="currency"
            placeholder="Selecciona la moneda"
            :options="currencyCatalog"
            :value="paymentCurrency"
            :disabled="isLoading || disabled"
            required
            @input="onChangeCurrency($event, props.row.id)"
            @change="onChangeCurrency($event, props.row.id)"
          />
        </BTableColumn>
        <BTableColumn
          :visible="isVisible"
          field="exchangeRate"
          internal
        >
          <AppInputField
            id="exchangeRate"
            name="exchangeRate"
            placeholder="0.00"
            :value="exchangeRate"
            :disabled="isLoading || disabled"
            @input="onChangePayment($event, props.row.id)"
            @change="onChangePayment($event, props.row.id)"
          />
        </BTableColumn>
        <BTableColumn
          field="voucherSeries"
          internal
        >
          <AppInputField
            id="voucherSeries"
            name="voucherSeries"
            placeholder="P"
            :value="voucherSeries"
            :disabled="isLoading || disabled"
            @input="onChangeInvoice($event, props.row.id)"
            @change="onChangeInvoice($event, props.row.id)"
          />
        </BTableColumn>
        <BTableColumn
          field="voucherConsecutive"
          internal
        >
          <AppInputField
            id="voucherConsecutive"
            name="voucherConsecutive"
            placeholder="1"
            type="number"
            min="1"
            :value="voucherConsecutive"
            :disabled="isLoading || disabled"
            @input="onChangeInvoice($event, props.row.id)"
            @change="onChangeInvoice($event, props.row.id)"
          />
        </BTableColumn>
        <BTableColumn
          field="actions"
          internal
        >
          <span class="actions">
            <a
              v-if="concepts.length > 1"
              class="button is-danger"
              @click="deleteRow(props.row.id)"
            >
              <BIcon
                icon="delete"
                aria-hidden="true"
              />
            </a>
          </span>
        </BTableColumn>
      </template>
      <template
        slot="detail"
        slot-scope="props"
      >
        <DocumentsRelated
          :id="props.row.id"
          :documents="props.row.documentsRelated"
        />
      </template>
    </BTable>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import moment from 'moment-timezone';

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import {
  wayTopay,
  currency,
} from '@machete/common-catalogs';

const arrayToOptions = array => array.map(
  ({ key, value }) => ({
    value: key,
    label: `${key} - ${value}`,
  }),
);

export default {
  name: 'NewComplementPayments',
  components: {
    AppTooltip: () => import(/* webpackChunkName: "app-tooltip" */ '@/components/AppTooltip.vue'),
    AppSelectField: () => import(/* webpackChunkName: "app-select-field" */ '@/components/AppSelectField.vue'),
    DocumentsRelated: () => import(/* webpackChunkName: "invoice-concept-taxes" */ '@/components/Admin/Invoices/NewDocumentRelated/NewDocumentRelated.vue'),
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
    AdvancedValues: () => import(/* webpackChunkName: "invoice-concept-taxes" */ '@/components/Admin/Invoices/NewDocumentRelated/AdvancedValues.vue'),
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentTypeCatalog: arrayToOptions(wayTopay),
      advanced: false,
      advancedClicked: false,
      currencyCatalog: arrayToOptions(currency),
      selected: null,
      openedDetailed: [1],
      columns: [
        {
          label: 'Forma de Pago',
          field: 'paymentMethod',
          centered: true,
        },
        {
          label: 'Fecha del pago',
          field: 'paymentDate',
          centered: true,
        },
        {
          label: 'Moneda',
          field: 'description',
          centered: true,
        },
        {
          visible: false,
          label: 'Tipo de cambio',
          field: 'exchangeRate',
          centered: true,
        },
        {
          label: 'Serie',
          field: 'voucherSeries',
          centered: true,
        },
        {
          label: 'Folio',
          field: 'voucherConsecutive',
          centered: true,
        },
      ],
      paymentTemplate: () => ({
        wayPay: '01',
        currency: 'MXN',
        amount: '',
        exchangeRate: 1,
        operationNumber: null,
        issuingRfc: null,
        bankName: null,
        issuingAccount: null,
        receiverRfc: null,
        receiverAccount: null,
        paymentDate: moment().unix(),
        documentsRelated: [
          {
            id: 1,
            documentId: '',
            documentSeries: '',
            documentConsecutive: '',
            documentPreviousBalance: '',
            documentCurrency: 'MXN',
            documentExchangeRate: 1,
            documentPaymentMethod: 'PPD',
            documentPartialityNumber: '',
            documentAmountPaid: '',
            documentOutstandingBalance: '',
          },
        ],
      }),
      calendarProps: {
        placeholder: 'DD/MM/AAAA',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        dayNames: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'],
        editable: true,
        datetimeFormatter: date => moment(date).format('DD/MM/YYYY HH:mm'),
      },
    };
  },
  computed: merge(
    mapState({
      productServiceKeyCatalog: ({ ui }) => ui.catalogs.productServiceKey,
      paymentCurrency: state => state.invoice.complement.payments[0].currency,
      wayPay: state => state.invoice.complement.payments[0].wayPay,
      concepts: ({ invoice }) => invoice.complement.payments,
      exchangeRate: state => state.invoice.complement.payments[0].exchangeRate,
      operationNumber: state => state.invoice.complement.payments[0].exchangeRate,
      issuingRfc: state => state.invoice.complement.payments[0].issuingRfc,
      bankName: state => state.invoice.complement.payments[0].bankName,
      issuingAccount: state => state.invoice.complement.payments[0].issuingAccount,
      receiverRfc: state => state.invoice.complement.payments[0].receiverRfc,
      receiverAccount: state => state.invoice.complement.payments[0].exchangeRate,
      voucherSeries: state => state.invoice.voucherSeries,
      voucherConsecutive: state => state.invoice.voucherConsecutive,
    }),
    mapGetters({
      totalCurrency: 'invoice/totalCurrency',
    }),
    {
      cash() {
        return this.wayPay === '01';
      },
      paymentTypeSelectedValue() {
        return this.paymentTypeCatalog.find(curr => curr.value === this.wayPay);
      },
      currencySelectedValue() {
        return this.currencyCatalog.find(curr => curr.value === this.paymentCurrency);
      },
      privatePaymentDate() {
        return moment(
          this.timestampToDate(this.$store.state.invoice.complement.payments[0].paymentDate),
        ).toDate();
      },
      isVisible() {
        if (this.disabled || this.isLoading) {
          if (this.paymentCurrency !== 'MXN') {
            this.columns[3].visible = true;
            return true;
          }

          this.columns[3].visible = false;
          return false;
        } if (this.paymentCurrency !== 'MXN') {
          this.columns[3].visible = true;
          return true;
        }

        this.columns[3].visible = false;
        return false;
      },
    },
  ),
  methods: merge(
    mapMutations({
      setPaymentValue: 'invoice/updatePayment',
      addPayment: 'invoice/addPayment',
      deletePayment: 'invoice/deletePayment',
      deleteConceptTax: 'invoice/deleteConceptTax',
      setVoucherValue: 'invoice/setValue',
    }),
    mapActions({ getCatalog: 'ui/getCatalog' }),
    {
      addRow() { this.addPayment(this.paymentTemplate()); },
      deleteRow(index) { this.deletePayment(index); },
      onChangePayment(event) {
        const { name: accessor, value } = event.target;
        if (accessor === 'wayPay' && value === '01') {
          this.setPaymentValue({
            accessor: 'bankName',
            value: null,
          });
          this.setPaymentValue({
            accessor: 'issuingAccount',
            value: null,
          });
          this.setPaymentValue({
            accessor: 'issuingRfc',
            value: null,
          });
          this.setPaymentValue({
            accessor: 'receiverAccount',
            value: null,
          });
          this.setPaymentValue({
            accessor: 'receiverRfc',
            value: null,
          });
        }
        this.setPaymentValue({ accessor, value });
      },
      onChangeCurrency(event) {
        const { name: accessor, value } = event.target;
        this.setPaymentValue({ accessor, value });
      },
      onInput(event) {
        const date = moment(Date.parse(event)).unix();
        this.setPaymentValue({ accessor: 'paymentDate', value: date });
      },
      onChangeInvoice(event) {
        const { name: accessor, value } = event.target;
        this.setVoucherValue({ accessor, value });
      },
      onDetailsClose(row) {
        const index = this.openedDetailed.indexOf(row.id);
        this.openedDetailed.slice(index, 1);
      },
      onChangeSelected(id) {
        this.selected = id;
      },
      onClearSelected() {
        this.selected = '';
      },
      onChangeAdvanced() {
        if (!this.advancedClicked) {
          this.advancedClicked = true;
          window.FMApi.manualTriggerExperiment();
        }
      },
      toggleDetail(id) {
        if (this.openedDetailed.includes(id)) {
          const index = this.openedDetailed.indexOf(id);
          this.openedDetailed.pop(index);
        } else {
          this.openedDetailed.push(id);
        }
      },
      timestampToDate(timestamp) {
        const parsedTimestamp = parseInt(timestamp, 10);
        // eslint-disable-next-line
        if (isNaN(parsedTimestamp)) return this.dateParser(timestamp);
        const timestampNumber = Number(timestamp) * 1000;
        const finalDate = new Date(timestampNumber);
        const strDate = `${(finalDate.getMonth() + 1)}/${finalDate.getDate()}/${finalDate.getFullYear()} ${finalDate.getHours()}:${finalDate.getMinutes()}`;
        return strDate;
      },
      dateParser: date => moment(new Date(date)).toDate(),
    },
  ),
};
</script>

<style scoped>
.title.is-4 {
  margin-bottom: 0;
}

.header-label {
  padding-right: 0.25rem;
}

.button.add-concept {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.button.add-concept .icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}

.add-concept-label {
  padding-left: .5rem;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.product-service-key-field,
.product-service-key-field .field {
  width: 150px;
  max-width: 150px;
}

.selected-field.product-service-key-field,
.selected-field.product-service-key-field .field {
  width: 400px;
  max-width: 400px;
}

.unit-key-field,
.unit-key-field .field {
  width: 120px;
  max-width: 120px;
}

.selected-field.unit-key-field,
.selected-field.unit-key-field .field {
  width: 250px;
  max-width: 250px;
}

.description-field.selected-field {
  width: 400px;
}
</style>

<style>
.box.concepts th,
.box.concepts td {
  vertical-align: middle;
  text-align: center;
}

.box.concepts .label:not(:last-child) {
  margin-bottom: 0;
}

.new-invoice.concepts input[type='number'] {
  -moz-appearance: textfield;
}

.new-invoice.concepts input::-webkit-outer-spin-button,
.new-invoice.concepts input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.box.concepts .label:not(:last-child) {
  margin-right: 1rem;
}
</style>
